import { requestStateData } from './requestStateData'
import { useStateData } from './useStateData'
import { SignupState } from '../types'

export const fetchTaxpayerDetails = () =>
  requestStateData(
    'taxpayerDetails',
    ({ signupSession: { comfeService } }: SignupState) =>
      comfeService.getTaxpayerDetails()
  )

export const useTaxpayerDetails = () =>
  useStateData('taxpayerDetails', fetchTaxpayerDetails)
